import { Instance, Objekt, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { resources } from '../resources';
import { AdminCouponService } from '../services/adminCouponService';
import { LanguageService } from '../services/languageService';
import { AdminController } from './adminController';

export class AdminCouponsIndexController extends AdminController {
    private table: Table;

    constructor(
        instances: Instance,
        private adminCouponService: AdminCouponService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initToolbarButtons(): void {
        this.helper.iconButton(
            '.btn-admin-index',
            this.dom,
            () => {
                this.state.goBack('admin.index');
            },
            '',
            true,
            [],
        );

        this.helper.iconButton('.btn-coupons-new', this.dom, () => {
            this.adminCouponService.newDialogByAdmin().then(() => {
                this._drawContent();
            });
        });
    }

    protected override _initTable(): void {
        if (!this.table) {
            this.table = new Table(
                this.dom,
                'table',
                this.adminCouponService.getTableOptions(),
            );

            this.table.setActions([
                {
                    style: () => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                        ];
                    },
                    click: (coupon) => {
                        this.adminCouponService
                            .editDialog(coupon, '/admin/')
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ]);

            this.table.eventAction = (params) => {
                params.set('query', this.query);
                params.set('fields', this.adminCouponService.getTableFields());
                this.adminCouponService.getAll(params).then((response) => {
                    const count = response.get<number>('count');
                    this.table.setCount(count);
                    const coupons = response.get<Objekt[]>('coupons');
                    this.table.setData(coupons);
                });
            };

            this.table.render();
        } else {
            this.table.refresh();
        }
    }
}

export const adminCouponsIndexController = app.controller(
    resources.adminCouponsIndexController,
    [
        resources.instances,
        resources.adminCouponService,
        resources.languageService,
    ],
    AdminCouponsIndexController,
);
